import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { selectAppRoles } from '../admin/Admin.Dux'
import './MultiSelect.scss'
import SelectField from './SelectField'

class SelectAppRolesField extends Component {
  static defaultProps = {
    appRoles: [],
  }

  render() {
    const { appRoles, placeholder, multi, t } = this.props
    return (
      <SelectField
        placeholder={placeholder || `${multi ? t('App roles') : t('App role')}`}
        {...this.props}
        options={appRoles}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  appRoles: selectAppRoles(state),
})

export default compose(withTranslation(), connect(mapStateToProps))(SelectAppRolesField)
